import Report from "../../../../report";
import {ViewType} from "../../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../../@types";
import ReportEffortsDistributionByProject_Settings from "./settings";
import SavedView from "../../../../../saved-view/saved-view";
import ApiView from "../../../../../../gd/api/view";

export default class ReportEffortsDistributionByProject extends Report<ReportEffortsDistributionByProject_Settings> {

    static reportName   : string = "By project"

    declare settings    : ReportEffortsDistributionByProject_Settings

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_EFFORTS_DISTRIBUTION_BY_PROJECT
        super(data);

        this.icon        = "isvg-effort-by-project"
        this.description = "Shows where efforts are spent within a project, providing insight into work focus and resource use."

        this.settings    = new ReportEffortsDistributionByProject_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportEffortsDistributionByProject {
        return new ReportEffortsDistributionByProject(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportEffortsDistributionByProject_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

}
